import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/motion";

export default function CaseStudySpotlight() {
  return (
    <section id="work" className="px-5 sm:px-8 py-20 lg:py-28 scroll-mt-24" data-testid="case-study-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-2xl">
          <SectionLabel>Featured Work</SectionLabel>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-[44px] tracking-tight text-[#01193D] leading-tight">
            Results our clients brag about
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-12">
          <div className="slow-zoom relative rounded-3xl overflow-hidden min-h-[480px] flex items-end" data-testid="case-study-card">
            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=75"
              alt="Meridian Logistics operations platform dashboard"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#01193D] via-[#01193D]/55 to-[#01193D]/15" />
            <div className="relative p-8 sm:p-12 lg:p-14 w-full">
              <span className="font-mono-brand text-[11px] uppercase tracking-[0.18em] text-[#91E0F1]">Meridian Logistics · Supply Chain</span>
              <h3 className="font-display font-bold text-white text-2xl sm:text-3xl lg:text-4xl tracking-tight mt-3 max-w-2xl leading-tight">
                How Meridian cut document processing time by 90%
              </h3>
              <div className="flex flex-wrap gap-3 mt-6">
                {["90% faster processing", "26.5 hrs saved weekly", "ROI in one quarter"].map((chip) => (
                  <span key={chip} className="inline-flex items-center gap-1.5 backdrop-blur-md bg-white/15 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full">
                    <Zap size={12} className="text-[#09B2ED]" /> {chip}
                  </span>
                ))}
              </div>
              <Link to="/contact" data-testid="case-study-link" className="group inline-flex items-center gap-2 text-[#09B2ED] font-semibold mt-8 hover:gap-3.5 transition-all">
                Read the full story <ArrowRight size={17} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
